module.exports = __webpack_public_path__ + "static/media/forbes.1c8ad8fd.svg";